import React from 'react';
import { Icon } from '../icon';
import Icons from '@/const/icons';
import { Typography } from '../typography';
import clsx from 'clsx';

interface Props {
	message?: string;
	className?: string;
	classNameIcon?: string;
}

export const EmptyUsers: React.FC<Props> = ({
	message,
	className,
	classNameIcon,
}) => {
	return (
		<div
			className={clsx('flex flex-col items-center justify-center', className)}
		>
			<Icon
				src={Icons.usersEmptyState}
				className={clsx('!w-[175px] !h-[140px]', classNameIcon)}
			/>
			<Typography type="regular-16">
				{message || 'There are currently no clients for this case.'}
			</Typography>
		</div>
	);
};
